import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { EndpointHint, type AdminClient } from '../../../modules/core/index.js'
import { createAiBriefingsAdminApi } from '../adminApi.js'
import { usdLabel } from '../labels.js'

/**
 * "AI briefings: 14 this month · 9 questions · 3 emailed · $0.02" on the admin's client detail: the add-on's usage
 * mirror with where the license stands. Counts only; a briefing's words are its reader's.
 */
export function AdminClientBriefingsLine({ client, clientId }: { client: AdminClient; clientId: string }) {
  const api = useMemo(() => createAiBriefingsAdminApi(client), [client])
  const query = useQuery({ queryKey: ['admin', 'client', clientId, 'briefings'], queryFn: () => api.clientUsage(clientId) })
  if (query.isPending) {
    return <p className="text-xs text-ink-mid">AI briefings: counting…</p>
  }
  if (query.isError) {
    return <p className="text-xs text-ink-mid">AI briefings: not available on this API.</p>
  }
  const { data, feature } = query.data
  const totals = data.totals
  return (
    <p className="text-xs text-ink">
      <span className="font-bold">AI briefings:</span>{' '}
      {!feature.enabled ? (
        <span className="text-ink-mid">not licensed ({feature.reason.replace(/_/g, ' ')})</span>
      ) : totals.briefings + totals.questions + totals.refused + totals.failed + totals.empty === 0 ? (
        <span className="text-ink-mid">none this month</span>
      ) : (
        <>
          {totals.briefings} this month · {totals.questions} question{totals.questions === 1 ? '' : 's'} · {totals.emails} emailed · {totals.empty} empty · {totals.failed} failed · {totals.refused} refused by the guard · {usdLabel(totals.costUsd)}
        </>
      )}
      <EndpointHint className="ml-2">GET /admin/clients/{'{clientId}'}/briefings</EndpointHint>
    </p>
  )
}
